// extracted by mini-css-extract-plugin
export default {"align":"UserView_align__OhCyb"};